import {createGlobalStyle} from "styled-components";
import {Colors} from "./colors";

const GlobalStyle = createGlobalStyle`
  html, body, div, span, applet, object, iframe,
  h1, h2, h3, h4, h5, h6, p, blockquote, pre,
  a, abbr, acronym, address, big, cite, code,
  del, dfn, em, img, ins, kbd, q, s, samp,
  small, strike, strong, sub, sup, tt, var,
  b, u, i, center,
  dl, dt, dd, ol, ul, li,
  fieldset, form, label, legend,
  table, caption, tbody, tfoot, thead, tr, th, td,
  article, aside, canvas, details, embed, 
  figure, figcaption, footer, header, hgroup, 
  menu, nav, output, ruby, section, summary,
  time, mark, audio, video, span {
    margin: 0;
    padding: 0;
    border: 0;
    vertical-align: baseline;
    font-family: "Poppins", sans-serif;
  }

  ol, ul {
    list-style: none;
  }
  blockquote, q {
      quotes: none;
  }
  blockquote:before, blockquote:after,
  q:before, q:after {
      content: '';
      content: none;
  }
  table {
      border-collapse: collapse;
      border-spacing: 0;
  }

  *, *::before, *::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  html {
    font-size: 100%; 
  }
  
  body {
    font-size: 1rem;
    font-family: "Inter", sans-serif;
  }
  
  a {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }
  
  .MuiDrawer-paper {
    position: relative !important;
    border-right: 0 !important;
    z-index: 999 !important;
  }
  
  .MuiAlert-message {
    white-space: pre-wrap;
  }

  .MuiGrid-spacing-xs-1, .MuiGrid-spacing-xs-2, .MuiGrid-spacing-xs-3, .MuiGrid-spacing-xs-4, .MuiGrid-spacing-xs-5, .MuiGrid-spacing-xs-6, .MuiGrid-spacing-xs-7, .MuiGrid-spacing-xs-8, .MuiGrid-spacing-xs-9, .MuiGrid-spacing-xs-10 {
    width: 100%;
    margin: 0;
  }
  
  img {
    max-width: 100%;
  }

  .MuiButton-root {
    text-transform: none;
  }
  
  .MuiTabs-indicator {
    background-color: ${Colors.lightViolet};
    height: 4px;
  }
  
  .MuiTab-root {
    color: #000;
    text-transform: none;
    font-size: 1rem;
    font-weight: 500;
  }
  
  div[role="tooltip"] {
    z-index: 99999999;
  }

  input:-webkit-autofill {
    -webkit-background-clip: text;
  }

  .MuiFormHelperText-root.Mui-error {
    color: ${Colors.error60};
  }

  .MuiDialog-paper {
    border-radius: 16px;
  }

  .MuiMenu-paper {
    border-radius: 16px;

    .MuiMenuItem-root {
      padding: 12px 16px;
    }
  }
  
  .MuiTabs-root {
    position: relative;
    
    &::after {
      content: ' ';
      background-color: ${Colors.grayBorder};
      height: 1px;
      width: 100%;
      position: absolute;
      bottom: 0;
      z-index: 0;
    }
    
    .MuiTab-root {
      &.Mui-selected {
        span {
          color: ${Colors.primary50};
        }
      }
    }
    
    .MuiTabs-indicator {
      background-color: ${Colors.primary50};
      height: 2px;
      z-index: 1;
    }
  }
`;

export default GlobalStyle;
